import axios from 'axios'
import {Notification, MessageBox, Message} from 'element-ui'
import {getToken} from '@/utils/auth'
import context from '../main'
import {removeToken} from './auth'
import Vue from 'vue'

let API_URL = ''
if (process.env.NODE_ENV === 'development') {
  API_URL = 'http://localhost:8899/jdl-api'
  // API_URL = 'http://yhjdltest.natapp1.cc/jdl-api'
} else {
  if (window.location.href.search('jdlboot') !== -1) {
    API_URL = 'http://jdlboot.jiedilia.com:8899/jdl-api/'
  } else {
    API_URL = 'https://api.sisbro.cn/jdl-api'
  }
}
Vue.prototype.API_URL = API_URL
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: API_URL,
  // 超时
  timeout: 300000
})
// request拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['x-access-token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    if (config.platform) {
      config.headers['platform'] = config.platform
    }
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(res => {
    const code = res.data.code
    if (code === 401) {
      MessageBox.confirm(
        '登录状态已过期，您可以继续留在该页面，或者重新登录',
        '系统提示',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        removeToken()
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    } else if (code === 200) {
      return res.data
    } else if (res.config.queryType === 'code') {
      return res.data
    } else {
      Message({
        message: res.data.message,
        type: 'error',
        duration: 5 * 1000
      })
      return false
    }
  },
  error => {
    if (error.message.indexOf('401') != -1) {
      //重新登录
      location.href = '/login'
      //记录 登录前页面
      window.localStorage.setItem('befromUrlName', context.$route.name)
      window.localStorage.setItem('befromUrlQuery', JSON.stringify(context.$route.query))
      window.localStorage.setItem('befromUrlParams', JSON.stringify(context.$route.params))
      return
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js